import { render, staticRenderFns } from "./ProductFunction.vue?vue&type=template&id=6b6086c5&scoped=true&"
import script from "./ProductFunction.vue?vue&type=script&lang=js&"
export * from "./ProductFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6086c5",
  null
  
)

export default component.exports